/** Karantena / QC lota — samo ako je tip točno "Brašno" (usklađeno s backendom). */

export type IngredientTypeLookup = {
  type_id?: number;
  code?: string | null;
  name?: string;
  is_active?: boolean;
  sort_order?: number;
};

export type IngredientWithType = {
  ingredient_type?: string | null;
  ingredient_type_id?: number | null;
  zboogie_ingredient_types?: IngredientTypeLookup | null;
};

/** Naziv tipa iz lookup tablice ili legacy polja s API-ja */
export function ingredientTypeLabel(
  ing?: IngredientWithType | string | null
): string | null {
  if (ing == null) return null;
  if (typeof ing === 'string') return ing;
  return (
    ing.zboogie_ingredient_types?.name ??
    ing.zboogie_ingredient_types?.code ??
    ing.ingredient_type ??
    null
  );
}

export function isFlourIngredientType(
  ingredientOrType?: string | null | IngredientWithType
): boolean {
  const name = ingredientTypeLabel(ingredientOrType ?? null);
  return name?.trim() === 'Brašno';
}
